var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBarra(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 4.5,
    fill: "white",
    stroke: "transparent"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M52.2909 58.8277L51.8175 57.5185H51.7533C51.3414 58.0755 50.9161 58.4631 50.4774 58.6813C50.0441 58.8938 49.4771 59 48.7763 59C47.9151 59 47.2357 58.7359 46.7382 58.2076C46.2461 57.6793 46 56.9271 46 55.9509C46 54.9288 46.3317 54.1766 46.995 53.6942C47.6637 53.2061 48.6693 52.9363 50.012 52.8846L51.5687 52.8329V52.4109C51.5687 51.4347 51.1033 50.9466 50.1725 50.9466C49.4557 50.9466 48.6132 51.1792 47.6449 51.6443L46.8345 49.8699C47.8669 49.29 49.0117 49 50.2688 49C51.4724 49 52.3952 49.2814 53.0371 49.8441C53.679 50.4068 54 51.2624 54 52.4109V58.8277H52.2909ZM51.5687 54.3661L50.6219 54.4005C49.9104 54.4235 49.3808 54.5613 49.0331 54.814C48.6854 55.0666 48.5115 55.4513 48.5115 55.9681C48.5115 56.7089 48.9074 57.0792 49.6991 57.0792C50.2661 57.0792 50.7182 56.9041 51.0552 56.5538C51.3975 56.2036 51.5687 55.7384 51.5687 55.1585V54.3661Z",
    fill: "#008746"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 42H76",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarra);
export default __webpack_public_path__ + "static/media/barra.2c60c1af4fca3ed4b75abdb55e060186.svg";
export { ForwardRef as ReactComponent };